import React, { Component }  from 'react'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import firebase from 'firebase'
import ModalTarifasAvianca from './ModalTarifasAvianca';

class TarifasAvianca extends Component {
    constructor(props){
        super(props);
        this.state = {
            isActive: false,
            updating: false,
            tarifas: [],
            tarifa: {},
            tiposVehiculo: []
        }
    }

    componentDidMount(){ 
        this.getTarifas();
        this.getTiposVehiculo();
    }

    getTiposVehiculo(){
        firebase.database().ref('Tipos_Vehiculos').once('value').then(snap => {
            let tiposVehiculo = [];
            snap.forEach(element => {
                let e = element.val();
                tiposVehiculo.push({ ...e, key: element.key });
            });
            this.setState({ tiposVehiculo });
        })
    }

    getTarifas(){
        firebase.database().ref('TarifasAvianca').on('value', snap => {
            let tarifas = [];
            snap.forEach(element => {
                let e = element.val()
                tarifas.push({ ...e, key: element.key });
            });
            this.setState({ tarifas });
        });
    }

    toggleModal() { this.setState({ isActive: !this.state.isActive }) }

    btnEditar(cell,row) {
		return  <button className="btn btn-success btn-sm" onClick={() => {this.handleClick(row)}} >Editar</button>;
    }
    
    handleClick(tarifa){
        if(this.state.tarifa !== {})
            this.setState({ tarifa: {} });

        this.setState({ tarifa, updating: true });
        this.toggleModal();
    }

    render(){
        return (
            <div style={{ marginTop: '5%', width: '90%', marginLeft: '5%' }} >
				<h1 className="titulo">Tarifas</h1>
                <ModalTarifasAvianca isActive={this.state.isActive} tarifa={this.state.tarifa} updating={this.state.updating} toggleModal={() => this.toggleModal()} />
                <BootstrapTable data={ this.state.tarifas }
                    ref='table' pagination={ true } search={ true } hover>
                    <TableHeaderColumn dataField='key' isKey={true} dataSort={true} hidden >key</TableHeaderColumn>
                    <TableHeaderColumn dataField='tipo' dataSort={true}>Nombre</TableHeaderColumn>
                    <TableHeaderColumn dataField='origen' dataAlign='center' dataSort={true}>Origen</TableHeaderColumn>
                    <TableHeaderColumn dataField='destino' dataSort={true}>Destino</TableHeaderColumn>
                    <TableHeaderColumn dataField='edit' dataAlign='center' dataFormat={this.btnEditar.bind(this)}>Editar</TableHeaderColumn>
                </BootstrapTable>
            </div>
        );
    }
}

export default TarifasAvianca;


// WEBPACK FOOTER //
// ./src/Components/Tarifas/TarifasAvianca.js